/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScrapeLinkMetadataResponseLinksMetadata
 */
export interface ScrapeLinkMetadataResponseLinksMetadata {
    /**
     * 
     * @type {string}
     * @memberof ScrapeLinkMetadataResponseLinksMetadata
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapeLinkMetadataResponseLinksMetadata
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapeLinkMetadataResponseLinksMetadata
     */
    srcUrl?: string;
}

/**
 * Check if a given object implements the ScrapeLinkMetadataResponseLinksMetadata interface.
 */
export function instanceOfScrapeLinkMetadataResponseLinksMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScrapeLinkMetadataResponseLinksMetadataFromJSON(json: any): ScrapeLinkMetadataResponseLinksMetadata {
    return ScrapeLinkMetadataResponseLinksMetadataFromJSONTyped(json, false);
}

export function ScrapeLinkMetadataResponseLinksMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrapeLinkMetadataResponseLinksMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'srcUrl': !exists(json, 'src_url') ? undefined : json['src_url'],
    };
}

export function ScrapeLinkMetadataResponseLinksMetadataToJSON(value?: ScrapeLinkMetadataResponseLinksMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
        'src_url': value.srcUrl,
    };
}

